/**
 * "Open in terminal" on the project page: a new tab on the Terminal page in
 * the repo's local clone (or a configuration's cwd), with the user's default
 * shell. The same path as the Terminal's own "+" → shell with a folder
 * (`openLocalTab(label, undefined, { cwd })`): no new spawn path.
 *
 * The tab remembers where it came from (`returnTo`), so the Terminal shows a
 * "Back to project" chip; the project tab stays open behind it. Coming back
 * re-runs Check setup without the cache (`markTerminalOpened`): what the
 * user fixed by hand (brew install …) turns ✓.
 *
 * The terminal store and page switch are imported lazily: the project page
 * must not pull the Tauri APIs in eagerly (tests/tauriImportsAreLazy).
 */
import { markTerminalOpened } from './doctor/doctorStore';

const baseName = (p) =>
  String(p || '')
    .replace(/[\\/]+$/, '')
    .split(/[\\/]/)
    .pop() || 'Terminal';

/**
 * Open `cwd` (absolute) in a new terminal tab. `repoPath` is the repo whose
 * setup check refreshes on return; `projectName` labels the way back.
 */
export async function openInTerminal({ cwd, repoPath, projectName, label }) {
  if (!cwd) return null;
  markTerminalOpened(repoPath || cwd);
  const [{ useTerminalExtStore }, { setActiveTab }] = await Promise.all([import('../../../store/terminalExtStore'), import('../../../store/uiModalStore')]);
  const tabId = useTerminalExtStore
    .getState()
    .openLocalTab(label || baseName(cwd), undefined, { cwd }, { returnTo: { panel: 'projects.panel', label: projectName || '' } });
  setActiveTab('terminal.panel');
  return tabId;
}
